type Settings = {
  sensitivity: number;
  fov: number;
  volume: number;
};

type OnResume = () => void;
type OnSettings = (s: Settings) => void;

export class PauseMenu {
  private readonly el: HTMLElement;
  private visible = false;

  constructor(
    private settings: Settings,
    private readonly onResume: OnResume,
    private readonly onSettings: OnSettings,
  ) {
    this.el = document.createElement("div");
    this.el.id = "hud-pause";
    this.el.className = "screen-overlay";
    this.el.style.zIndex = "200";

    this.el.innerHTML = this.buildHtml();
    document.body.appendChild(this.el);
    this.bindEvents();
  }

  private buildHtml(): string {
    const slider = (id: string, label: string, min: number, max: number, step: number, val: number) =>
      `<label class="pause-row">
        <span class="pause-row__label">${label}</span>
        <input id="${id}" class="pause-row__slider" type="range" min="${min}" max="${max}" step="${step}" value="${val}">
        <span id="${id}-val" class="pause-row__value">${val}</span>
      </label>`;

    return `
      <div class="screen-panel screen-panel--narrow">
        <div class="screen-title screen-title--compact" style="margin-bottom:8px">PAUSED</div>
        <div class="pause-stack">
          ${slider("s-sens", "SENSITIVITY", 1, 10, 1, Math.round(this.settings.sensitivity * 1000))}
          ${slider("s-fov", "FOV", 50, 90, 5, this.settings.fov)}
          ${slider("s-vol", "VOLUME", 0, 100, 5, Math.round(this.settings.volume * 100))}
        </div>
        <div class="screen-actions" style="margin-top:18px">
          <button id="pause-resume" class="screen-button">RESUME</button>
        </div>
      </div>
    `;
  }

  private bindEvents(): void {
    this.el.querySelector("#pause-resume")!.addEventListener("click", () => this.hide());

    for (const [id, key] of [["s-sens", "sensitivity"], ["s-fov", "fov"], ["s-vol", "volume"]] as const) {
      const input = this.el.querySelector(`#${id}`) as HTMLInputElement;
      const valEl = this.el.querySelector(`#${id}-val`) as HTMLElement;
      input.addEventListener("input", () => {
        const raw = parseFloat(input.value);
        valEl.textContent = String(raw);
        if (key === "sensitivity") this.settings.sensitivity = raw / 1000;
        else if (key === "fov") this.settings.fov = raw;
        else this.settings.volume = raw / 100;
        this.onSettings({ ...this.settings });
      });
    }
  }

  show(): void {
    this.visible = true;
    this.el.classList.add("is-visible");
  }

  hide(): void {
    this.visible = false;
    this.el.classList.remove("is-visible");
    this.onResume();
  }

  toggle(): void {
    this.visible ? this.hide() : this.show();
  }

  get isPaused(): boolean {
    return this.visible;
  }

  dispose(): void {
    this.el.remove();
  }
}
